// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"Fieldset_fieldset__3M-3d","inset":"Fieldset_inset__1N9iv"};